// import { useState } from "react";
import "./NewEngineering.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../Images/Engineeringnewpic.png'
import Footer from "../Component/NewFooter";

const services = [
  {
    id: "valves",
    label: "Valves Asset Management",
    title: "Jeyshawn Engineering services exemplifies innovation, precision, and technical excellence.",
    intro:
      "From the initial conceptualization to detailed design and project delivery, we apply a holistic approach that balances creativity, technical rigor, and operational practicality. Our engineering capabilities ensure that every project is structurally sound, cost-effective, and optimized for maximum efficiency, while meeting stringent safety and environmental standards.",
    
    intro1:
      "Our services encompass a wide range of disciplines, including civil, structural, mechanical, electrical, instrumentation, and process engineering, enabling us to provide fully integrated solutions for complex projects. Leveraging cutting-edge engineering tools and methodologies, we deliver designs that are not only robust but also sustainable, scalable, and aligned with industry’s best practices.",

    intro2:
      "At Jeyshawn Engineering Limited, engineering is more than just technical execution. it is a commitment to excellence, innovation, and client satisfaction. By combining deep industry knowledge with practical experience, we transform concepts into reality, ensuring projects are delivered on time, within budget, and to the highest standards of quality and reliability.",


  },
];

 const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction & Camp Setup",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                 href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

// const currentHref = "/engineering";

export default function Engineering() {
  return (
    <>
      <div className="img_carrierseng">
        <img src={Avatar1} alt="" />
      </div>

      <section className="service-detail">
        <div className="service-detail__layout">

          {/* Left — Content (your existing JSX, unchanged) */}
          <div className="service-detail__content">
            <h2 className="service-detail__title">{services[0].title}</h2>
            <span className="service-detail__divider" />
            <p className="service-detail__intro">{services[0].intro}</p>
            <p className="service-detail__intro">{services[0].intro1}</p>
            <p className="service-detail__intro">{services[0].intro2}</p>
            
          </div>

          {/* Right — Nav links instead of state buttons */}
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink
                key={s.href}
                to={s.href}
                className={({ isActive }) =>
                  `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`
                }
              >
                {s.label}
              </NavLink>
            ))}
          </nav>

        </div>
      </section>
      <Footer/>
    </>
  );
}
